module.exports = function () {
    $('body').on('cart:update product:afterAddToCart', (e, data) => {
        if (data && data.dynamicYieldEvent) {
            const dyEvent = new CustomEvent('dynamicYieldEvent', {
                detail: data.dynamicYieldEvent,
            });
            document.body.dispatchEvent(dyEvent);
        }
    });
};
